module.exports = __webpack_public_path__ + "img/wind_direction.39e02e17.svg";